export default __webpack_public_path__ + "static/media/sliderIndicator.e56cf506.svg";